module.exports = __webpack_public_path__ + "img/customer-stisfication.1cec54e6.svg";